var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useAppDispatch } from '../../../hooks';
import { setMatchState } from '../../../store/match';
import { useErrorHandler } from '../../../hooks/useErrorHandler';
import { bachelorSelectPlayer } from '../../../api';
import { Delimiter } from '../../atoms/Delimiter';
const votingStyle = {
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
};
const PlayerContainer = styled.div `
  display: flex;
  align-items: center;
`;
export function BachelorTarget({ votingPlayer, player, onClose }) {
    const { errorHandler } = useErrorHandler();
    const dispatch = useAppDispatch();
    const onVote = (playerId) => __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield bachelorSelectPlayer(playerId);
            dispatch(setMatchState(response));
            onClose === null || onClose === void 0 ? void 0 : onClose(player);
        }
        catch (err) {
            errorHandler(err);
        }
    });
    return votingPlayer ? (_jsxs(Paper, Object.assign({ sx: votingStyle }, { children: [_jsx(PlayerContainer, { children: _jsxs("div", { children: [_jsxs(Typography, Object.assign({ variant: "h4" }, { children: ["\u0425\u043E\u043B\u043E\u0441\u0442\u044F\u043A ", (votingPlayer === null || votingPlayer === void 0 ? void 0 : votingPlayer.player.gameName) || ''] })), _jsx(Typography, Object.assign({ variant: "subtitle1" }, { children: "\u0418\u0449\u0435\u0442, \u043A\u043E\u0433\u043E \u0437\u0430\u0431\u0440\u0430\u0442\u044C \u0441 \u0441\u043E\u0431\u043E\u0439" }))] }) }), player && player !== votingPlayer && (_jsxs(_Fragment, { children: [_jsx(MoreVertIcon, {}), _jsx(PlayerContainer, { children: _jsxs("div", { children: [_jsx(Typography, Object.assign({ variant: "h4" }, { children: (player === null || player === void 0 ? void 0 : player.player.gameName) || '' })), _jsx(Typography, Object.assign({ variant: "subtitle1" }, { children: "\u041F\u043E\u043A\u0440\u044B\u0432\u0430\u0435\u0442\u0441\u044F \u0445\u043E\u043B\u043E\u0434\u043D\u044B\u043C \u043F\u043E\u0442\u043E\u043C" }))] }) }), _jsx(Delimiter, { top: "14px" }), _jsx(Button, Object.assign({ variant: "contained", startIcon: _jsx(CheckCircleOutlineIcon, {}), onClick: () => onVote((player === null || player === void 0 ? void 0 : player.id) || '') }, { children: "\u0417\u0430\u0431\u0440\u0430\u0442\u044C \u0441 \u0441\u043E\u0431\u043E\u0439" }))] }))] }))) : null;
}
